import { render, staticRenderFns } from "./horizontal-navbar-2.vue?vue&type=template&id=63b03893&scoped=true"
import script from "./horizontal-navbar-2.vue?vue&type=script&lang=js"
export * from "./horizontal-navbar-2.vue?vue&type=script&lang=js"
import style0 from "./horizontal-navbar-2.vue?vue&type=style&index=0&id=63b03893&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b03893",
  null
  
)

export default component.exports